import { useTranslation } from 'module/hooks/use-translation';
import { ShortSB } from 'module/ui/components/styles';
import { PeopleListRow } from 'api/account-people/types';
import { useMemo } from 'react';
import styled, { css } from 'styled-components';
import { noRoleId } from 'components/organisms/account-people/utils/use-page-params';
import { useExternalTeamMemberRoleField } from '../utils/use-external-team-member-role-field';

const Tab = styled.div<{ $active: boolean }>`
  ${ShortSB};
  padding: 0 var(--spacing-03);
  border-radius: var(--border-radius-default);
  ${({ $active }) =>
    $active
      ? css`
          background-color: var(--scarlet-background-tertiary);
          color: var(--text-selected);
        `
      : css`
          color: var(--text-secondary);
          cursor: pointer;
        `};
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const TabsContainer = styled.div`
  width: 500px;
  margin: 0 auto;
  height: 32px;
  border-radius: var(--border-radius-small);
  overflow: hidden;
  border: 2px solid var(--field-border-focused);
  display: flex;
  align-items: center;
  padding: var(--spacing-01);
  ${Tab} {
    flex: 1;
  }
`;
const Wrapper = styled.div``;

type Props = {
  value: number;
  onChange: (role: number) => void;
  people: PeopleListRow[];
};

export const PeoplePageRoleSelector = ({
  value: selectedRole,
  onChange,
  people,
}: Props) => {
  const all = useTranslation('all' as any);
  const { field } = useExternalTeamMemberRoleField();
  const roleOptions = useMemo(() => {
    return field?.metaData?.options ?? [];
  }, [field]);
  const allRoles = useMemo(
    () => [
      {
        id: noRoleId,
        label: all,
      },
      ...roleOptions.map(({ label, value }) => ({
        id: value,
        label,
      })),
    ],
    [all, roleOptions],
  );

  return (
    <Wrapper>
      <TabsContainer>
        {allRoles.map((role) => (
          <Tab
            key={role.id}
            $active={selectedRole === role.id}
            onClick={() => onChange(role.id)}
          >
            {role.label}{' '}
            {selectedRole === role.id && people.length > 0
              ? ` (${people.length})`
              : ''}
          </Tab>
        ))}
      </TabsContainer>
    </Wrapper>
  );
};
